<template>
    <div>
        <h5>Select a new date or leave empty to clear the date</h5>
        <div class="md-layout">
            <md-datepicker v-model="selectedDate" md-immediately :md-debounce="10" :md-disabled-dates="disabledDates">
                <label>Date</label>
            </md-datepicker>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { DATE_TYPES } from '@/utils/constants';

export default {
    name: 'SetDate',
    props: {
        selectedDate: {
            type: [Date, String, null],
            default: null
        }
    },
    data() {
        return {
            disabledDates: (date) => {
                const x = moment(date).format(DATE_TYPES.internationalDate);
                const now = moment().format(DATE_TYPES.internationalDate);
                return !moment(x).isSameOrAfter(now, 'day');
            }
        };
    },
    watch: {
        selectedDate(val) {
            this.$emit('date-selected', val);
        }
    }
};
</script>

<style lang="scss" scoped>
.md-layout {
    margin-top: 15px;
}
</style>
